import { ErrorResponse } from '@core/types';

const isErrorResponse = <T>(obj: T | ErrorResponse): obj is ErrorResponse => {
  return !!(obj as ErrorResponse)?.status;
};

export default isErrorResponse;
